import { createSelector } from '@reduxjs/toolkit';
import { selectAllVariants } from '@ff-scene-plugins/photo-prints-redux/selectors/variantSelectors';
import { selectAllGroups, selectGroupById } from '@ff-scene-plugins/photo-prints-redux/slices/groupsSlice';
import { selectPhotoById } from '@ff-scene-plugins/photo-prints-redux/slices/photosSlice';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { findVariant } from '@ff-scene-plugins/photo-prints-shared/variants';

export const selectVariantByAttributes = createSelector([
    selectAllVariants,
    (_: PhotoPrintsPdpState, paperId: string) => paperId,
    (_: PhotoPrintsPdpState, paperId: string, sizeId: string) => sizeId,
    (_: PhotoPrintsPdpState, paperId: string, sizeId: string, borderId: string) => borderId
], (variants, paperId, sizeId, borderId) => {
    return findVariant(variants, { paperId, sizeId, borderId });
});

const selectGroupByPhotoId = createSelector([
    selectPhotoById,
    selectAllGroups
], (photo, groups) => {
    return groups.find(g => g.id === photo!.groupId)!;
});

export const selectVariantByPhotoId = createSelector([
    state => state,
    selectGroupByPhotoId
], (state, group) => {
    return selectVariantByGroupId(state, group.id);
});

export const selectVariantByGroupId = createSelector([
    selectAllVariants,
    selectGroupById
], (variants, group) => {
    return variants.find(v => v.id === group!.variantId)!;
});